import { switcher } from '../utils';
import { ACTIONS } from '../../const';
import objectRecord from '../object_record';
import R from 'ramda';

const validScale = R.compose(
    R.max(0.5),
    R.min(3)
);

const settingsShape = objectRecord({
    scale: 1,
    scaleCenter: null,
    showOthersHighlights: true,
});
const contentSettings = (existing = {}, updates = {}) => {
    const settings = settingsShape(existing, updates);
    if (settings.scale) {
        settings.scale = validScale(settings.scale);
    }
    return settings;
};

export const defaultContentSettings = contentSettings();

export default switcher(JSON.parse(localStorage.getItem('contentSettings')), {
    [ACTIONS.SET_CONTENT_SETTINGS](state, action) {
        const { content, settings } = action;

        const newState = R.over(
            R.lensPath([content.id]),
            (previousSettings = {}) => {
                return contentSettings(previousSettings, settings);
            },
            state
        );

        localStorage.setItem('contentSettings', JSON.stringify(newState));
        return newState;
    },
});



// WEBPACK FOOTER //
// ./src/reducers/content/settings.js